/* tslint:disable */
/* eslint-disable */

/**
 * 1 = SiteName
 * 2 = SiteLogo
 * 3 = SiteColor
 * 4 = TarifVisitePME
 * 5 = DelaiRappelConfirmationTransport
 * 6 = DelaiRappelClotureTransport
 * 7 = DelaiRappelConfirmationEchange
 * 8 = DelaiRappelClotureEchange
 * 9 = GoogleGeocodingRequestTemplate
 * 10 = GoogleGeocodingAPIKey
 * 11 = DebutEte
 * 12 = FinEte
 * 13 = EmailSMTP
 * 14 = EmailLogin
 * 15 = EmailPassword
 * 16 = EmailAdresseSource
 * 17 = EmailBCC
 * 18 = AzureClientId
 * 19 = AzureAuthority
 * 20 = AzureRedirectUri
 * 21 = EmailPort
 * 22 = EmailSSL
 * 23 = EmailAdresseSourceNom
 * 24 = EmailCompany
 * 25 = EmailAddress1
 * 26 = EmailAddress2
 * 27 = EmailProductName
 * 28 = EmailHomeUrl
 * 29 = EmailHelpUrl
 * 30 = EmailSupportUrl
 * 31 = EmailResetPasswordUrl
 * 32 = EmailSetPasswordUrl
 * 33 = SearchResultsMaxLength
 * 34 = LastClosedVisitesMaxLength
 * 35 = EIdCardReadIntervalInMonths
 * 36 = AgeMinimumAccesParc
 * 37 = DonnerieMax
 * 38 = GestionTarifTransportsDechets
 * 39 = GestionNumeroPesageDemandesTransports
 * 40 = RoleCitoyen
 * 41 = JourClotureAutomatiqueDemandesTransport
 * 42 = HeureClotureAutomatiqueDemandesTransport
 * 43 = DelaiRappelClotureAutomatiqueDemandesTransport
 * 44 = GeoLocAPI
 * 45 = GoogleApiUrl
 * 46 = GoogleApiKey
 * 47 = HereApiUrl
 * 48 = HereApiId
 * 49 = HereApiCode
 * 50 = ApportsPPAnonymes
 * 51 = ImpressionAutomatique
 * 52 = AmianteId
 * 53 = DelaiDesactivationPersonnePhysique
 * 54 = IdentifiantDemandeTransportBase
 * 55 = RachatQuotaMontantPaiement
 * 56 = RachatQuotaIbanPaiement
 * 57 = DemandeAccesMontantPaiement
 * 58 = DemandeAccesIbanPaiement
 * 59 = DemandeAccesBicPaiement
 * 60 = DemandeAccesAdresseDestination
 * 61 = DemandeAccesEmailDestination
 * 62 = UrlSitePublic
 * 63 = EnTeteFormulaire
 * 64 = UtilisePlaquePP
 * 65 = DelaiInactivitePlaquePP
 * 66 = UtiliseJoker
 * 67 = VolumeJokerAutorise
 * 68 = JoursJokerAutorise
 * 69 = NombreJokerAutorise
 * 70 = SoldeMinimumPM
 * 71 = QuotaJournalier
 * 72 = UniteVisitePM
 * 73 = NomFormulaireCotisation
 * 74 = NomCotisations
 * 75 = NomPaiementCotisation
 * 76 = InterventionPhotoObligatoire
 * 77 = BlocageQuotaJournalier
 * 78 = UtiliseRepresentant
 * 79 = LimiteRepresentant
 * 80 = BloqueSiLimiteRepresentant
 * 81 = UtiliseSoldePMSiDepassementQuota
 * 82 = PrisePhotoPDA
 * 83 = UtilisePlaquePM
 * 84 = DelaiInactivitePlaquePM
 * 85 = UtiliseEtatStock
 * 86 = UtiliseEtatConteneur
 * 87 = RoleIdsEC
 * 88 = AfficheListeRepresentant
 * 89 = PMESoldeNegatif
 */
export enum ParametreValues {
  SiteName = 1,
  SiteLogo = 2,
  SiteColor = 3,
  TarifVisitePME = 4,
  DelaiRappelConfirmationTransport = 5,
  DelaiRappelClotureTransport = 6,
  DelaiRappelConfirmationEchange = 7,
  DelaiRappelClotureEchange = 8,
  GoogleGeocodingRequestTemplate = 9,
  GoogleGeocodingAPIKey = 10,
  DebutEte = 11,
  FinEte = 12,
  EmailSMTP = 13,
  EmailLogin = 14,
  EmailPassword = 15,
  EmailAdresseSource = 16,
  EmailBCC = 17,
  AzureClientId = 18,
  AzureAuthority = 19,
  AzureRedirectUri = 20,
  EmailPort = 21,
  EmailSSL = 22,
  EmailAdresseSourceNom = 23,
  EmailCompany = 24,
  EmailAddress1 = 25,
  EmailAddress2 = 26,
  EmailProductName = 27,
  EmailHomeUrl = 28,
  EmailHelpUrl = 29,
  EmailSupportUrl = 30,
  EmailResetPasswordUrl = 31,
  EmailSetPasswordUrl = 32,
  SearchResultsMaxLength = 33,
  LastClosedVisitesMaxLength = 34,
  EIdCardReadIntervalInMonths = 35,
  AgeMinimumAccesParc = 36,
  DonnerieMax = 37,
  GestionTarifTransportsDechets = 38,
  GestionNumeroPesageDemandesTransports = 39,
  RoleCitoyen = 40,
  JourClotureAutomatiqueDemandesTransport = 41,
  HeureClotureAutomatiqueDemandesTransport = 42,
  DelaiRappelClotureAutomatiqueDemandesTransport = 43,
  GeoLocAPI = 44,
  GoogleApiUrl = 45,
  GoogleApiKey = 46,
  HereApiUrl = 47,
  HereApiId = 48,
  HereApiCode = 49,
  ApportsPPAnonymes = 50,
  ImpressionAutomatique = 51,
  AmianteId = 52,
  DelaiDesactivationPersonnePhysique = 53,
  IdentifiantDemandeTransportBase = 54,
  RachatQuotaMontantPaiement = 55,
  RachatQuotaIbanPaiement = 56,
  DemandeAccesMontantPaiement = 57,
  DemandeAccesIbanPaiement = 58,
  DemandeAccesBicPaiement = 59,
  DemandeAccesAdresseDestination = 60,
  DemandeAccesEmailDestination = 61,
  UrlSitePublic = 62,
  EnTeteFormulaire = 63,
  UtilisePlaquePP = 64,
  DelaiInactivitePlaquePP = 65,
  UtiliseJoker = 66,
  VolumeJokerAutorise = 67,
  JoursJokerAutorise = 68,
  NombreJokerAutorise = 69,
  SoldeMinimumPM = 70,
  QuotaJournalier = 71,
  UniteVisitePM = 72,
  NomFormulaireCotisation = 73,
  NomCotisations = 74,
  NomPaiementCotisation = 75,
  InterventionPhotoObligatoire = 76,
  BlocageQuotaJournalier = 77,
  UtiliseRepresentant = 78,
  LimiteRepresentant = 79,
  BloqueSiLimiteRepresentant = 80,
  UtiliseSoldePMSiDepassementQuota = 81,
  PrisePhotoPDA = 82,
  UtilisePlaquePM = 83,
  DelaiInactivitePlaquePM = 84,
  UtiliseEtatStock = 85,
  UtiliseEtatConteneur = 86,
  RoleIdsEC = 87,
  AfficheListeRepresentant = 88,
  PMESoldeNegatif = 89
}
